import type { EitherTranslatedOrError, SimpleFormatMessage } from 'components/secondaryMarket/shared/Clipboard/types';
import type { SecondaryBatchColumnDefinitionContext } from 'state/workspaces/secondary-market/batch/model';

const getPossibleValues = (metadata?: unknown) => {
  if (Array.isArray(metadata)) {
    return metadata.filter((value): value is string => typeof value === 'string');
  }

  return (metadata as SecondaryBatchColumnDefinitionContext | undefined)?.values ?? [];
};

export const translateColumnPossibleValues = (
  pastedValue: string,
  formatSimpleMessage: SimpleFormatMessage,
  metadata?: unknown,
) => {
  const possibleValues = getPossibleValues(metadata);

  if (possibleValues.includes(pastedValue)) {
    return { status: 'success', value: pastedValue } as EitherTranslatedOrError<string>;
  }

  if (pastedValue.length >= 3) {
    const matches = possibleValues.filter(x => x?.toLowerCase().includes(pastedValue?.toLowerCase()));
    if (matches.length === 1) {
      return { status: 'success', value: matches[0] } as EitherTranslatedOrError<string>;
    }
  }

  const error = formatSimpleMessage('moreMenu.pasteFromClipboard.error.invalidNotInTheList', { value: pastedValue });
  return { status: 'error', error } as EitherTranslatedOrError<string>;
};
